module.exports = "<!DOCTYPE HTML PUBLIC \"-//IETF//DTD HTML 2.0//EN\">\n<html><head>\n<title>404 Not Found</title>\n</head><body>\n<h1>Not Found</h1>\n<p>The requested URL /3.6.0/light/img/bootstrap-colorpicker/hue-horizontal.png was not found on this server.</p>\n</body></html>\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bootstrap-colorpicker/hue-horizontal.png.html
// module id = 439
// module chunks = 2